import { CaptureError } from '../contracts';

/** A missing/blocked audio output must not leave an opened microphone stuck starting. */
export async function waitForAudioReady(resumed: Promise<void>, timeoutMs = 10_000) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    await Promise.race([
      resumed,
      new Promise<never>((_resolve, reject) => {
        timer = setTimeout(() => reject(new CaptureError('unsupported')), timeoutMs);
      }),
    ]);
  } finally {
    if (timer !== undefined) clearTimeout(timer);
  }
}
